/* Stroke icon set. One path table, one component. */

const PATHS: Record<string, string> = {
  search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm10 2-4.35-4.35',
  plus: 'M12 5v14M5 12h14',
  chat: 'M21 11.5a8.4 8.4 0 0 1-9 8.4 9 9 0 0 1-4-.9L3 21l1.9-4.6A8.4 8.4 0 0 1 4 11.5a8.5 8.5 0 0 1 17 0Z',
  user: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
  cal: 'M6 4h12a3 3 0 0 1 3 3v11a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3ZM16 2v4M8 2v4M3 10h18',
  brief: 'M5 7h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3ZM16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16',
  bell: 'M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0',
  filter: 'M22 3H2l8 9.5V19l4 2v-8.5L22 3Z',
  back: 'M19 12H5M12 19l-7-7 7-7',
  x: 'M18 6 6 18M6 6l12 12',
  pin: 'M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0ZM12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z',
  clock: 'M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18ZM12 7v5l3 2',
  globe: 'M12 3a9 9 0 1 1 0 18 9 9 0 0 1 0-18ZM3 12h18M12 3a15 15 0 0 1 0 18 15 15 0 0 1 0-18Z',
  send: 'M22 2 11 13M22 2l-7 20-4-9-9-4 20-7Z',
  shield: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10Z',
  car: 'M5 17h14M6.5 17v2M17.5 17v2M4 13l1.6-4.8A2 2 0 0 1 7.5 7h9a2 2 0 0 1 1.9 1.2L20 13v4H4v-4Z',
  swap: 'M7 4v13M7 4 4 7M7 4l3 3M17 20V7M17 20l3-3M17 20l-3-3',
  home: 'M3 10.5 12 3l9 7.5V21H3V10.5ZM9 21v-6h6v6',
  sort: 'M3 6h13M3 12h9M3 18h5M17 14l3 3 3-3',
  map: 'm9 3 6 3 6-3v15l-6 3-6-3-6 3V6l6-3ZM9 3v15M15 6v15',
  dollar: 'M12 2v20M17 6H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6',
  fwd: 'M5 12h14M12 5l7 7-7 7',
  camera: 'M4 7h3l1.6-2.4A1 1 0 0 1 9.4 4h5.2a1 1 0 0 1 .8.6L17 7h3a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2ZM12 17a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z',
  trash: 'M4 7h16M10 11v6M14 11v6M6 7l1 13a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-13M9 7V4h6v3',
  refresh: 'M21 12a9 9 0 1 1-2.6-6.4M21 3v6h-6',
  /* Safari's share control, drawn because we can only describe the menu
     it opens -- no browser lets a page open it. */
  'share-ios': 'M12 15V3M12 3 8.5 6.5M12 3l3.5 3.5M6 11H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2h-1',
};

interface Props {
  name: keyof typeof PATHS | string;
  size?: number;
  className?: string;
}

export function Icon({ name, size, className }: Props) {
  const d = PATHS[name];
  if (!d) return null;
  const style = size ? { width: size, height: size } : undefined;
  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={d} />
    </svg>
  );
}
